import ModalTiposDeMovimentos from './ModalTiposMovimentos';
import { Button, Modal } from 'react-bootstrap';
import { DataIso } from '@/shared/utils/datas';
import { ReadDefensoriaDto, ReadDefensorResponseDto, ReadNucleoDto } from '@/api.types';
import { useEffect, useRef, useState } from 'react';

interface ModalFiltrosRelatorioMovimentacoesProps {
  show: boolean;
  defensores: ReadDefensorResponseDto[];
  defensorias: ReadDefensoriaDto[];
  nucleos: ReadNucleoDto[];
  handleHide: () => void;
  handleBuscar: (params: parametrosRelatorioMovimentacoes) => void;
  /** Filtros atualmente aplicados na página (para exibir ao reabrir o modal). */
  valoresAtuais?: parametrosRelatorioMovimentacoes | null;
}

export interface parametrosRelatorioMovimentacoes {
  inicio: string;
  fim: string;
  ref: boolean;
  defensor: number;
  defensoria: number;
  nucleo: number;
  civel: boolean;
  criminal: boolean;
  tipos: number[];
}

export default function ModalFiltrosRelatorioMovimentacoes({
  show,
  defensores,
  defensorias,
  nucleos,
  handleHide,
  handleBuscar,
  valoresAtuais,
}: ModalFiltrosRelatorioMovimentacoesProps) {
  const hoje = new Date(Date.now());

  const [showModalTipos, setShowModalTipos] = useState(false);

  const [inicio, setInicio] = useState(
    DataIso(new Date(hoje.getFullYear(), hoje.getMonth(), 1)),
  );
  const [fim, setFim] = useState(
    DataIso(new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0)),
  );
  const [ref, setRef] = useState(true);
  const [civel, setCivel] = useState(true);
  const [criminal, setCriminal] = useState(true);

  const [defensorId, setDefensorId] = useState<number>(0);
  const [defensoriaId, setDefensoriaId] = useState<number>(0);
  const [nucleoId, setNucleoId] = useState<number>(0);
  const [tiposIds, setTiposIds] = useState<number[]>([]);
  const showAnteriorRef = useRef(false);

  // Sincroniza o estado do modal com os filtros aplicados na página apenas quando o modal é aberto.
  useEffect(() => {
    const acabouDeAbrir = show && !showAnteriorRef.current;
    showAnteriorRef.current = show;
    if (acabouDeAbrir && valoresAtuais) {
      setInicio(valoresAtuais.inicio ?? '');
      setFim(valoresAtuais.fim ?? '');
      setRef(Boolean(valoresAtuais.ref));
      setCivel(Boolean(valoresAtuais.civel));
      setCriminal(Boolean(valoresAtuais.criminal));
      setDefensorId(Number(valoresAtuais.defensor) || 0);
      setDefensoriaId(Number(valoresAtuais.defensoria) || 0);
      setNucleoId(Number(valoresAtuais.nucleo) || 0);
      setTiposIds(Array.isArray(valoresAtuais.tipos) ? valoresAtuais.tipos : []);
    }
  }, [show, valoresAtuais]);

  function onSubmit() {
    handleBuscar({
      civel: civel,
      criminal: criminal,
      defensor: defensorId,
      defensoria: defensoriaId,
      fim: fim,
      inicio: inicio,
      nucleo: nucleoId,
      ref: ref,
      tipos: tiposIds,
    });
    handleHide();
  }

  function handleDefinirTipos(tiposSelecionados: number[]) {
    setTiposIds(tiposSelecionados);
  }

  return (
    <Modal show={show} onHide={handleHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Filtros para Relatório de Movimentações</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-6">
            <div className="card">
              <div className="card-body">
                <label htmlFor="defensor" className="col-form-label">
                  Defensor(a):
                </label>
                <select
                  title="Fitlrar por Defensor(a)"
                  className="form-select"
                  onChange={(e) => {
                    setDefensorId(Number(e.target.value));
                  }}
                  value={defensorId || undefined}
                >
                  <option></option>
                  {defensores !== undefined &&
                    defensores !== null &&
                    defensores.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.pessoa?.nome}
                      </option>
                    ))}
                </select>
                <div className="row mt-3">
                  <div className="col-6">
                    <label htmlFor="inicio" className="form-label">
                      Início:
                    </label>
                    <input
                      id="inicio"
                      type="date"
                      className="form-control"
                      value={inicio}
                      onChange={(e) => {
                        setInicio(DataIso(e.target.value));
                      }}
                      required
                    />
                  </div>
                  <div className="col-6">
                    <label htmlFor="fim" className="form-label">
                      Fim:
                    </label>
                    <input
                      id="fim"
                      type="date"
                      className="form-control"
                      value={fim}
                      onChange={(e) => {
                        setFim(DataIso(e.target.value));
                      }}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="card">
              <div className="card-body">
                <label htmlFor="defensoria" className="col-form-label">
                  Defensoria:
                </label>
                <select
                  title="Filtrar por defensoria."
                  className="form-select"
                  onChange={(e) => {
                    setDefensoriaId(Number(e.target.value));
                  }}
                  value={defensoriaId || undefined}
                >
                  <option></option>
                  {defensorias !== undefined &&
                    defensorias !== null &&
                    defensorias.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.nome}
                      </option>
                    ))}
                </select>
                <label htmlFor="nucleo" className="col-form-label">
                  Núcleo:
                </label>
                <select
                  title="Fitlrar por núcleo"
                  className="form-select"
                  onChange={(e) => {
                    setNucleoId(Number(e.target.value));
                  }}
                  value={nucleoId || undefined}
                >
                  <option></option>
                  {nucleos !== undefined &&
                    nucleos !== null &&
                    nucleos.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.nome}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </div>

          <div className="col-12 pt-4">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div
                    className="form-check form-switch col-auto me-3 ms-2"
                    title="Marque para filtrar por referência ou desmarque para filtrar por recebimento."
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="referencia"
                      onChange={(e) => {
                        setRef(e.target.checked);
                      }}
                      checked={ref || false}
                    />
                    <label className="form-check-label" htmlFor="referencia">
                      Por data de referência.
                    </label>
                  </div>
                  <div className="form-check col-auto">
                    <input
                      id="civel"
                      name="civel"
                      className="form-check-input"
                      title="Área Cível"
                      type="checkbox"
                      onChange={(e) => {
                        setCivel(e.target.checked);
                      }}
                      checked={civel || false}
                    />
                    <label htmlFor="civel" className="form-check-label">
                      Registros do tipo cível.
                    </label>
                  </div>
                  <div className="form-check col-auto">
                    <input
                      id="criminal"
                      name="criminal"
                      className="form-check-input"
                      title="Área Criminal"
                      type="checkbox"
                      onChange={(e) => {
                        setCriminal(e.target.checked);
                      }}
                      checked={criminal || false}
                    />
                    <label htmlFor="criminal" className="form-check-label">
                      Registros do tipo criminal.
                    </label>
                  </div>
                  <div className="col-auto">
                    <button
                      className="btn btn-sm btn-outline-success"
                      title="Filtrar por tipo de movimento"
                      onClick={() => {
                        setShowModalTipos(true);
                      }}
                    >
                      Tipos de Movimentos
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="submit" variant="success" onClick={() => onSubmit()}>
          Buscar
        </Button>
      </Modal.Footer>

      <ModalTiposDeMovimentos
        show={showModalTipos}
        handleHide={() => setShowModalTipos(false)}
        handleBuscar={handleDefinirTipos}
      />
    </Modal>
  );
}
